import ApiResource from "../../Lib/ApiResource";


export default class PalettesResource extends ApiResource {

    commit(data) {
        return this.put('palettes', data);
    }

}
